function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0395 0.00310014C12.3692 -0.0302931 12.6636 0.209898 12.6969 0.539582L13.0294 3.82173C13.0465 3.99052 12.9913 4.15866 12.8776 4.28452C12.7638 4.41038 12.6021 4.4822 12.4324 4.4822H9.1C8.76863 4.4822 8.5 4.21357 8.5 3.8822C8.5 3.55083 8.76863 3.2822 9.1 3.2822H11.1208C10.0667 2.30004 8.6534 1.70005 7.1 1.70005C3.84152 1.70005 1.2 4.34157 1.2 7.60005C1.2 10.8585 3.84152 13.5 7.1 13.5C10.2456 13.5 12.8166 11.038 12.9906 7.93629C13.0092 7.60544 13.2924 7.35227 13.6233 7.37083C13.9541 7.38939 14.2073 7.67264 14.1887 8.00349C13.9793 11.7373 10.8858 14.7 7.1 14.7C3.17878 14.7 0 11.5213 0 7.60005C0 3.67882 3.17878 0.500046 7.1 0.500046C8.83352 0.500046 10.4218 1.1216 11.6542 2.153L11.5031 0.66051C11.4697 0.330826 11.7099 0.0364935 12.0395 0.00310014Z",
  fill: "#249AF3"
});

function SvgLoadMoreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadMoreIcon);
export default __webpack_public_path__ + "static/media/LoadMoreIcon.4a3be4a4.svg";
export { ForwardRef as ReactComponent };